import React, { useState } from 'react';

const SpendingMore = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head">
        <h2 className="qs-card__title">
          Spending More Than Income?
        </h2>
      </div>
      <div className="qs-card__body">
        <p className="qs-card__sub">
          At the time your car loan was approved or while active, were you consistently spending more than your monthly income?
        </p>
        <div className="qs-actions">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes ${selectedAnswer == 487 ? 'btn-active' : ''}`}
            onClick={() => handleClick(487)}>
            Yes
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--no ${selectedAnswer == 488 ? 'btn-active' : ''}`}
            onClick={() => handleClick(488)}>
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default SpendingMore;
